import React, { useEffect } from "react";
import { BaseButton } from "@/components/ui-kit/Buttons/BaseButton";
import { ButtonType } from "@/types/ui-kit/buttons";
import Image from "next/image";
import { useAuthUrls } from "@/hooks/useAuthUrls";
import { DIGI_SUBS_PRICE_VALUE } from "@/constants/reporter";
import useScrollingRect from "@/hooks/useScrollingRect";
import { pushToDataLayer } from "@/utils/pushToDataLayer";
import { PostUnlockedPaywallProps } from "@/types/modules/post/components";

export const PostUnlockedPaywall: React.FC<PostUnlockedPaywallProps> = ({ postId }) => {
  const { getSubscriptionUrl } = useAuthUrls();
  const isCurrentSection = useScrollingRect("postUnlockedPaywall");

  useEffect(() => {
    if (isCurrentSection) {
      pushToDataLayer({
        event: "article_interaction",
        interaction_type: "content_consumed",
      });
    }
  }, [isCurrentSection]);

  return (
    <div
      className="relative mx-auto w-full max-w-[345px] bg-gray-100 px-[24px] py-[32px] dark:bg-dark-100 lg:max-w-[600px] lg:px-[40px] lg:py-[48px]"
      id="postUnlockedPaywall"
    >
      <div className="mx-auto flex max-w-[480px] flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center">
          <Image src="/assets/images/unlocked-paywall.png" width={152} height={64} alt="" />
        </div>

        <h3 className="mb-2 font-mercury text-3xl font-semibold dark:text-white">
          Nezávislá žurnalistika existuje jen díky vám
        </h3>
        <p className="font-sm font-sans font-light text-dark dark:text-white">
          Získejte přístup ke kompletnímu obsahu již&nbsp;od&nbsp;{DIGI_SUBS_PRICE_VALUE}&nbsp;Kč&nbsp;měsíčně.
        </p>
        <div className="mx-auto mb-8 mt-6 flex w-full max-w-[280px] flex-col gap-[16px]">
          <div className="overflow-hidden rounded-full">
            <BaseButton
              href={getSubscriptionUrl()}
              title="Předplaťte si Reportér"
              type={ButtonType.Primary}
              fullWidth
            />
          </div>
        </div>
      </div>
    </div>
  );
};
